import { CircularProgress, Typography } from "@mui/material"
import React from "react"
import { FlexBox } from "./FlexBox"

interface IUploadProgressTextProps {
  primaryText: string
  secondaryText: string
}

export const UploadProgressText = ({ primaryText, secondaryText }: IUploadProgressTextProps) => (
  <FlexBox ai="start" fullWidth gap vertical>
    <Typography color="textPrimary" fontSize=".9rem" sx={{ minWidth: "2rem" }}>
      {primaryText}
    </Typography>
    <FlexBox gap>
      <Typography color="textSecondary" fontSize=".9rem" sx={{ minWidth: "2rem" }}>
        {secondaryText}
      </Typography>
      <CircularProgress sx={{ width: "1.5rem !important", height: "1.5rem !important" }} />
    </FlexBox>
  </FlexBox>
)
